const VitalsDisplay = ({ vitals }) => {
  const getVitalStatus = (type, value) => {
    if (!value) return 'normal';

    switch (type) {
      case 'ta_systolique':
        if (value < 90 || value > 140) return 'danger';
        if (value < 100 || value > 130) return 'warning';
        return 'normal';
      case 'ta_diastolique':
        if (value < 60 || value > 90) return 'danger';
        if (value < 65 || value > 85) return 'warning';
        return 'normal';
      case 'pouls':
        if (value < 50 || value > 100) return 'danger';
        if (value < 60 || value > 90) return 'warning';
        return 'normal';
      case 'temperature':
        if (value < 36 || value > 38) return 'danger';
        if (value < 36.5 || value > 37.5) return 'warning';
        return 'normal';
      case 'spo2':
        if (value < 90) return 'danger';
        if (value < 95) return 'warning';
        return 'normal';
      case 'imc':
        if (value < 16 || value > 30) return 'danger';
        if (value < 18.5 || value > 25) return 'warning';
        return 'normal';
      default:
        return 'normal';
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'danger':
        return 'text-red-600';
      case 'warning':
        return 'text-orange-600';
      default:
        return 'text-green-600';
    }
  };

  const vitalsConfig = [
    { key: 'ta_systolique', label: 'TA Systolique', unit: 'mmHg', combined: true },
    { key: 'ta_diastolique', label: 'TA Diastolique', unit: 'mmHg', hidden: true },
    { key: 'pouls', label: 'Pouls', unit: 'bpm' },
    { key: 'temperature', label: 'Température', unit: '°C' },
    { key: 'spo2', label: 'SpO₂', unit: '%' },
    { key: 'poids', label: 'Poids', unit: 'kg' },
    { key: 'taille', label: 'Taille', unit: 'cm' },
    { key: 'imc', label: 'IMC', unit: '' }
  ];

  return (
    <div className="grid grid-cols-2 gap-4" data-testid="vitals-display">
      {vitalsConfig.map(({ key, label, unit, combined, hidden }) => {
        if (hidden) return null;

        let value = vitals[key];
        let displayValue = value || '-';
        let status = getVitalStatus(key, value);

        // Special handling for blood pressure
        if (combined && key === 'ta_systolique') {
          const systolique = vitals.ta_systolique;
          const diastolique = vitals.ta_diastolique;
          if (systolique && diastolique) {
            displayValue = `${systolique}/${diastolique}`;
            const systStatus = getVitalStatus('ta_systolique', systolique);
            const diastStatus = getVitalStatus('ta_diastolique', diastolique);
            status = systStatus === 'danger' || diastStatus === 'danger' ? 'danger' :
                     systStatus === 'warning' || diastStatus === 'warning' ? 'warning' : 'normal';
          }
        }

        return (
          <div key={key} className="p-3 bg-gray-50 rounded-lg" data-testid={`vital-${key}`}>
            <p className="text-xs text-gray-500 mb-1">{label}</p>
            <p className={`text-xl font-bold ${getStatusColor(status)}`}>
              {displayValue}
              {value && unit && <span className="text-sm ml-1">{unit}</span>}
            </p>
          </div>
        );
      })}
    </div>
  );
};

export default VitalsDisplay;
